import { promotions } from '@/mocks/data';

const promoImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Lucky%20red%20gold%20Chinese%20new%20year%20style%20background%20with%20glowing%20envelope%20and%20gold%20coins%2C%20festive%20atmosphere%2C%20warm%20lighting%2C%20clean%20composition%2C%20elegant%20minimalist%2C%20soft%20bokeh%20background%2C%20celebration%20theme&width=600&height=400&seq=promo-new-register&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Red%20and%20gold%20lucky%20money%20theme%20with%20Chinese%20ingots%20and%20coins%20on%20warm%20gradient%20background%2C%20fortune%20concept%2C%20clean%20minimal%20product%20photography%20style%2C%20soft%20shadows%2C%20elegant%20composition&width=600&height=400&seq=promo-first-deposit&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Warm%20golden%20calendar%20with%20red%20highlights%20on%20soft%20cream%20background%2C%20daily%20checkin%20reward%20concept%2C%20lucky%20Chinese%20theme%2C%20clean%20modern%20design%2C%20soft%20lighting%2C%20minimalist%20composition&width=600&height=400&seq=promo-sign-in&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Two%20hands%20sharing%20a%20glowing%20golden%20gift%20box%20on%20warm%20red%20gradient%20background%2C%20friendship%20and%20reward%20concept%2C%20Chinese%20lucky%20style%2C%20soft%20elegant%20lighting%2C%20clean%20composition&width=600&height=400&seq=promo-invite&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Luxurious%20golden%20VIP%20crown%20with%20red%20velvet%20texture%20on%20dark%20warm%20background%2C%20premium%20membership%20concept%2C%20elegant%20Chinese%20style%2C%20soft%20dramatic%20lighting%2C%20clean%20minimalist%20composition&width=600&height=400&seq=promo-vip&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Chinese%20national%20day%20celebration%20with%20red%20lanterns%20and%20golden%20fireworks%20on%20warm%20festive%20background%2C%20lucky%20and%20joyful%20atmosphere%2C%20clean%20design%2C%20soft%20lighting%2C%20elegant%20composition&width=600&height=400&seq=promo-festival&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Golden%20spinning%20wheel%20with%20red%20prizes%20on%20warm%20festive%20background%2C%20lucky%20draw%20concept%2C%20Chinese%20style%2C%20celebration%20atmosphere%2C%20clean%20composition%2C%20soft%20golden%20lighting&width=600&height=400&seq=promo-daily-lottery&orientation=landscape',
  8: 'https://readdy.ai/api/search-image?query=Stack%20of%20golden%20coins%20and%20red%20envelopes%20on%20warm%20cream%20background%2C%20wealth%20and%20fortune%20concept%2C%20Chinese%20lucky%20aesthetic%2C%20clean%20product%20photography%2C%20soft%20elegant%20lighting&width=600&height=400&seq=promo-first-500&orientation=landscape',
};

const promoListImages: Record<number, string> = {
  3: 'https://readdy.ai/api/search-image?query=Warm%20golden%20calendar%20with%20red%20highlights%20on%20soft%20cream%20background%2C%20daily%20checkin%20reward%20concept%2C%20lucky%20Chinese%20theme%2C%20clean%20modern%20design%2C%20soft%20lighting%2C%20minimalist%20composition&width=200&height=128&seq=promo-sign-in&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Luxurious%20golden%20VIP%20crown%20with%20red%20velvet%20texture%20on%20dark%20warm%20background%2C%20premium%20membership%20concept%2C%20elegant%20Chinese%20style%2C%20soft%20dramatic%20lighting%2C%20clean%20minimalist%20composition&width=200&height=128&seq=promo-vip&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Golden%20spinning%20wheel%20with%20red%20prizes%20on%20warm%20festive%20background%2C%20lucky%20draw%20concept%2C%20Chinese%20style%2C%20celebration%20atmosphere%2C%20clean%20composition%2C%20soft%20golden%20lighting&width=200&height=128&seq=promo-daily-lottery&orientation=landscape',
  8: 'https://readdy.ai/api/search-image?query=Stack%20of%20golden%20coins%20and%20red%20envelopes%20on%20warm%20cream%20background%2C%20wealth%20and%20fortune%20concept%2C%20Chinese%20lucky%20aesthetic%2C%20clean%20product%20photography%2C%20soft%20elegant%20lighting&width=200&height=128&seq=promo-first-500&orientation=landscape',
};

export default function PromotionList() {
  const featured = promotions.filter((p) => p.featured);
  const others = promotions.filter((p) => !p.featured);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门送彩金活动
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            精选最受欢迎的送彩金活动，立即参与赢取丰厚奖励
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-6">
          {featured.map((promo) => (
            <div
              key={promo.id}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 group cursor-pointer"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={promoImages[promo.id]}
                  alt={promo.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full">
                    {promo.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <span className="text-xs text-accent-600 font-medium bg-accent-50 px-2 py-0.5 rounded-full">
                  {promo.categoryName}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mt-2 mb-2 line-clamp-2 leading-snug">
                  {promo.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                  {promo.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-lg font-heading font-bold text-primary-500">
                    {promo.amount}
                  </span>
                  <span className="text-xs text-foreground-500">{promo.platform}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="space-y-3">
          {others.map((promo) => (
            <div
              key={promo.id}
              className="bg-background-50 rounded-lg p-4 flex flex-col sm:flex-row items-start sm:items-center gap-4 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex-shrink-0 w-full sm:w-24 h-16 rounded-md overflow-hidden">
                <img
                  src={promoListImages[promo.id]}
                  alt={promo.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs text-accent-600 font-medium bg-accent-50 px-2 py-0.5 rounded-full">
                    {promo.categoryName}
                  </span>
                  <span className="text-xs bg-background-200/70 text-foreground-600 px-2 py-0.5 rounded-full">
                    {promo.tag}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1">
                  {promo.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-1 mt-0.5">{promo.description}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <span className="text-lg font-heading font-bold text-primary-500">{promo.amount}</span>
                <p className="text-xs text-foreground-500">{promo.platform}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}